import * as React from 'react';
import { JSX } from 'react';
import { observer } from 'mobx-react';
import { MyProfileModel } from '../../core/models/MyProfileModel';
import { useSystem } from '../../hooks/useSystem';

export interface SessionUserLoaderWidgetProps {
  children: (event: { user: MyProfileModel }) => JSX.Element;
}

export const SessionUserLoaderWidget: React.FC<SessionUserLoaderWidgetProps> = observer((props) => {
  const system = useSystem();

  if (system.user?.loaded) {
    return props.children({ user: system.user });
  }
  return null;
});
namespace S {}
